import { Button, Col, Drawer, Flex, Form, Input, Row, DatePicker, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import moment from 'moment';
import { useSelector } from 'react-redux';
import WorkflowManagementAPI from '../../../../restAPI/WorkflowManagementAPI';


const { Option } = Select;

const FilterCircular = ({
  openDrawer,
  closeDrawer,
  data,
  handleFilterDetailsChange,
  filterValues,
  screenName
}) => {
  const [searchValues, setSearchValues] = useState([]);
  const [drawerValues, setDrawerValues] = useState({});
  const [computedLabels, setComputedLabels] = useState({});
  const excludedKeys = [
    '__v',
    '_id',
    //'approvalStatus',
    'status',
    'approvers',
    'archivedBy',
    'branch',
    'comments',
    'company',
    'createdBy',
    'documents',
    'message',
    'requestType', 'subject', 'submittedAt', 'updatedAt'];

  const { companyId, token, userCompany } = useSelector(state => state.auth);
  const [searchUsersList, setSearchUsersList] = useState([]);

  const handleSearchFilter = () => {
    handleFilterDetailsChange(searchValues);
    closeDrawer();
    setSearchValues([])
  }

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setDrawerValues(data[0])
    }
  }, [data])

  useEffect(() => {
    setSearchValues(filterValues);
  }, [filterValues]);

  useEffect(() => {
    getUsersByCompanyId();
  }, [openDrawer]);


  const getValueByKey = (keyToFind, data) => {
    const item = data.find(item => item.key === keyToFind);
    return item ? item.value : null;
  }

  const formatLabel = (str) => {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  };

  const labelList = {
    archivedData: [
      { key: 1, label: 'Circulation Type', value: 'circulationType' },
      { key: 2, label: 'Approval Status', value: 'approvalStatus' },
      { key: 3, label: 'Initiator', value: 'initiator' },
      { key: 4, label: 'Created Date', value: 'createdAt' },
    ],
  };

  useEffect(() => {
    const relavantLabels = labelList[screenName] || [];
    const labels = {};

    Object.keys(drawerValues).forEach((key) => {
      const matchedLabel = relavantLabels.find((item) => item.value === key);
      labels[key] = matchedLabel ? matchedLabel.label : formatLabel(key.charAt(0).toUpperCase() + key.slice(1));
    });

    setComputedLabels(labels);

  }, [drawerValues, screenName])


  const approvalAtatusOptioins = [
    { key: '1', value: 'pending', label: 'Pending' },
    { key: '2', value: 'completed', label: 'Completed' },
    { key: '3', value: 'rejected', label: 'Rejected' },
  ];

  const circulationTypeOptioins = [
    { key: '1', value: 'hierarchy', label: 'Hierarchy' },
    { key: '2', value: 'parallel', label: 'Parallel' },
  ];

  function setUsersList(key, label, value) {
    return {
      key,
      label,
      value,
    };
  }

  const getUsersByCompanyId = async () => {
    var listOfObjects = [];

    await WorkflowManagementAPI.getUsersByCompanyId(companyId, token).then((res) => {
      var dataList = res.data

      for (let i = 0; i < dataList.length; i++) {
        listOfObjects.push(
          setUsersList(
            i,
            dataList[i]['name'],
            dataList[i]['name'],
          )
        )
      }
      setSearchUsersList(listOfObjects)
    }).catch((err) => {

    }).finally(() => {

    })
  };

  return (
    <div>
      <Drawer
        open={openDrawer}
        onClose={closeDrawer}
        // size='large'
        title="Search Filter"
        footer={[
          <Flex justify='flex-end' align='center' gap='large'>
            <Button onClick={closeDrawer}>
              Cancel
            </Button>
            <Button type="primary" onClick={handleSearchFilter}>
              Search
            </Button>
          </Flex>
        ]}
      >

        <Form layout="vertical">
          {Object.keys(drawerValues).map((single, index) =>
            !excludedKeys.includes(single) ? (
              <Row gutter={12} key={index}>
                <Col span={24}>
                  <Form.Item label={computedLabels[single]}>
                    {single === 'initiator' ? (
                      // <Input
                      //   placeholder="Type search value"
                      //   value={getValueByKey(single, searchValues)}
                      //   onChange={(e) => {
                      //     setSearchValues((prev) => {
                      //       const index = prev.findIndex((item) => item.key === single);
                      //       if (index > -1) {
                      //         const updateItems = [...prev];
                      //         updateItems[index].value = e.target.value;
                      //         return updateItems;
                      //       } else {
                      //         return [...prev, { key: single, value: e.target.value }];
                      //       }
                      //     });
                      //   }}
                      //   autoComplete="new-name"
                      // />
                      <Select
                        placeholder="Select a value"
                        value={getValueByKey(single, searchValues)}
                        options={searchUsersList}
                        onChange={(value) => {
                          setSearchValues((prev) => {
                            const index = prev.findIndex((item) => item.key === single);
                            if (index > -1) {
                              const updatedItems = [...prev];
                              updatedItems[index].value = value;
                              return updatedItems;
                            } else {
                              return [...prev, { key: single, value }];
                            }
                          });
                        }}
                        autoComplete="new-name"
                      ></Select>
                    ) : single === 'createdAt' ? (
                      <DatePicker
                        placeholder="Select a Date"
                        autoComplete="new-description"
                        value={getValueByKey(single, searchValues) ? moment(getValueByKey(single, searchValues)) : null} // ensure the value is a valid moment object
                        onChange={(date, dateString) => {
                          setSearchValues((prev) => {
                            const index = prev.findIndex((item) => item.key === single);
                            if (index > -1) {
                              const updateItems = [...prev];
                              updateItems[index].value = dateString;
                              return updateItems;
                            } else {
                              return [...prev, { key: single, value: dateString }];
                            }
                          });
                        }}
                      />
                    ) : single === 'approvalStatus' ? (
                      <Select
                        placeholder="Select a value"
                        value={getValueByKey(single, searchValues)}
                        onChange={(value) => {
                          setSearchValues((prev) => {
                            const index = prev.findIndex((item) => item.key === single);
                            if (index > -1) {
                              const updatedItems = [...prev];
                              updatedItems[index].value = value;
                              return updatedItems;
                            } else {
                              return [...prev, { key: single, value }];
                            }
                          });
                        }}
                        autoComplete="new-name"
                      >
                        {approvalAtatusOptioins.map((option) => (
                          <Option key={option.key} value={option.value}>
                            {option.label}
                          </Option>
                        ))}
                      </Select>
                    ) : single === 'circulationType' ? (
                      <Select
                        placeholder="Select a value"
                        value={getValueByKey(single, searchValues)}
                        onChange={(value) => {
                          setSearchValues((prev) => {
                            const index = prev.findIndex((item) => item.key === single);
                            if (index > -1) {
                              const updatedItems = [...prev];
                              updatedItems[index].value = value;
                              return updatedItems;
                            } else {
                              return [...prev, { key: single, value }];
                            }
                          });
                        }}
                        autoComplete="new-name"
                      >
                        {circulationTypeOptioins.map((option) => (
                          <Option key={option.key} value={option.value}>
                            {option.label}
                          </Option>
                        ))}
                      </Select>
                    ) : (
                      <></>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            ) : null
          )}
        </Form>
      </Drawer>
    </div>
  )
}

export default FilterCircular